// IMPORTAÇÃO DAS BIBLIOTECAS----------------------------------------------------------------------
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast, ToastContainer } from 'react-toastify';
import { useTranslation } from 'react-i18next';



// IMPORTAÇÃO DOS COMPONENTES----------------------------------------------------------------------
import { api } from '../../services/api.js';
import styles from "./register.module.css";
import logo from '../../img/logo6.png';
import ComponentLoad from "../../components/componentLoad/componentLoad.js";
import { FcGoogle } from 'react-icons/fc';
import { useAppContext } from "../../AppContext.js";



// COMPONENTE DE CADASTRO--------------------------------------------------------------------------
export default function Register() {
    // variáveis gerais
    const [componentLoading, setComponentLoading] = useState(true); // estado para controlar o carregamento do componente
    const [name, setName] = useState(""); // estado para armazenar o variável nome
    const [email, setEmail] = useState(""); // estado para armazenar o variável email
    const [password, setPassword] = useState(""); // estado para armazenar o variável senha
    const [confirmpassword, setConfirmpassword] = useState(""); // estado para armazenar o variável confirmação de senha
    const [code, setCode] = useState(""); // estado para armazenar o código de confirmação enviado por email
    const [showConfirmation, setShowConfirmation] = useState(false); // estado para mostrar o campo de confirmação do código.
    const [isSubmitting, setIsSubmitting] = useState(false); // estado que define carregamento durante submit
    const [showPassword, setShowPassword] = useState(false); // estado de definição de 'mostrar ou ocultar' senha
    const [showSuccessModal, setShowSuccessModal] = useState(false); // estado para mostrar o modal de sucesso
    const [showInfoModal, setShowInfoModal] = useState(false); // estado para mostrar o modal informativo (quando for necessário limitar cadastros)
    const [valorMensal, setValorMensal] = useState(""); // valores atualizados via useEffect
    const [regiaoPayment, setRegiaoPayment] = useState(""); // região do pagamento
    const [currency, setCurrency] = useState(""); // moeda do pagamento
    const [nameCoin, setNameCoin] = useState(""); // nome da moeda atualizado via useEffect
    const [freeTrialDays, setFreeTrialDays] = useState(0); // dias de expiração do plano free trial, atualizado via useEffect
    const navigate = useNavigate();
    const { t } = useTranslation(); // hook de tradução
    const { isApp } = useAppContext(); // define se está sendo acessado pelo app ou pelo site


    // Gerencia efeitos colaterais do modal (scroll lock, fechar com ESC).
    useEffect(() => {
        if (showInfoModal) {
            document.body.style.overflow = "hidden";
            const handleEsc = (e) => {
                if (e.key === "Escape") {
                    setShowInfoModal(false);
                    console.log("esc");
                }
            };
            window.addEventListener("keydown", handleEsc);

            // Função de limpeza
            return () => {
                document.body.style.overflow = "";
                window.removeEventListener("keydown", handleEsc);
            };
        }
    }, [showInfoModal]);



    // impede abrir o modal informativo caso o usuário tenha vindo da página promocional
    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const origin = urlParams.get('origin');
        if (origin === 'tsnotesPromo') {
            setShowInfoModal(false);
        }
    }, []);



    // useEffect para buscar os valores dos planos e a taxa de câmbio
    useEffect(() => {
        async function fetchPrices() {
            try {
                const response = await api.get('/values_plans_ads');
                setValorMensal(response.data.prices.valor1Convertido);
                setRegiaoPayment(response.data.prices.region);
                setCurrency(response.data.prices.currency);
                setNameCoin(response.data.prices.name);
                setFreeTrialDays(response.data.freeTrialDays);

                setComponentLoading(false); // desativa o carregamento do componente após obter os dados

            } catch (error) {
                console.error('Error fetching prices:', error);
                setComponentLoading(false);
                setShowInfoModal(false);
            }
        }
        fetchPrices();
    }, []);

    // função para criar um novo usuário
    async function handleSubmit(e) {
        e.preventDefault();
        setIsSubmitting(true);
        try {
            if (password !== confirmpassword) {
                toast.error(t("Error. Passwords do not match."));
                return;
            }
            await api.post('/auth/register', {
                name: name,
                email: email,
                password: password,
                confirmpassword: confirmpassword,
                language: navigator.language || 'en-US'
            });
            // console.log(response.data.msg); // somente para desenvolvimento
            setShowConfirmation(true); // mostra campo de confirmação
        } catch (error) {
            // console.log(error.response.data.msg); // somente para desenvolvimento
            if (error.response && error.response.status === 422) {
                toast.error(t("Registration error. Check if the email is already registered."));
            } else if (error.response && error.response.status === 400) {
                toast.error(t("Invalid data. Check the information and try again."));
            } else {
                toast.error(t("Registration error. Please try again later."));
            }
        } finally {
            setIsSubmitting(false); // Desativa o carregamento
        }
    }

    // função para confirmar o cadastro
    async function handleConfirm(e) {
        e.preventDefault();
        setIsSubmitting(true); // Ativa o estado de carregamento
        try {
            await api.post('/auth/activate', {
                email: email,
                code: code,
                language: navigator.language || 'en-US'
            });
            //console.log(response.data.msg); // somente para desenvolvimento
            setName(""); // Limpa o campo de nome
            setEmail(""); // Limpa o campo de email
            setPassword(""); // Limpa o campo de senha
            setConfirmpassword(""); // Limpa o campo de confirmação de senha
            setCode(""); // Limpa o campo de código
            setShowConfirmation(false); // Esconde o campo de confirmação
            setShowSuccessModal(true); // Exibe o modal de sucesso
        } catch (error) {
            console.log(error.response.data.msg);
            if (error.response && error.response.status === 422) {
                toast.error(t("Invalid or already used code. Check the code and try again."));
            } else {
                toast.error(t("Error confirming registration. Please try again later."));
            }
        } finally {
            setIsSubmitting(false); // Desativa o carregamento
        }
    }

    // Função para fechar o modal e redirecionar
    function handleCloseModal() {
        setShowSuccessModal(false);
        navigate('/');
    }



    // TELA DE CARREGAMENTO
    if (componentLoading) {
        return (
            <div className={styles.container}>
                <ComponentLoad />
            </div>

        );
    }



    // HTML do componente
    return (
        <div className={styles.container}>

            {/* cabeçalho superior com logo */}
            <div className={styles.brand} style={isApp ? { top: '45px' } : {top: '5px'}}>
                <div className={styles.logoCircle}>
                    <span className={styles.logoText}><img src={logo} alt="Logo" /></span>
                </div>
                <span className={styles.brandName}>tS notes</span>
            </div>

            <div className={styles.cadastroBox}>

                {/* titulo da página cadastro */}
                <h2 className={styles.title}>{t("Registration")}</h2>

                {/* formulário de cadastro */}
                <form onSubmit={handleSubmit} className={styles.form}>

                    {/* input nome */}
                    <input
                        type="text"
                        placeholder={t("Name")}
                        aria-label={t("Name")}
                        value={name}
                        onChange={(e) => setName(e.target.value)}
                        required
                        maxLength={50}
                        autoComplete="name"
                        className={styles.input}
                        disabled={showConfirmation || isSubmitting}
                    />

                    {/* input de email */}
                    <input
                        type="email"
                        placeholder="E-mail"
                        aria-label="E-mail"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                        maxLength={50}
                        className={styles.input}
                        disabled={showConfirmation || isSubmitting}
                    />

                    {/* input de senha */}
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder={t("Password")}
                        aria-label={t("Password")}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        required
                        minLength={6}
                        maxLength={20}
                        className={styles.input}
                        disabled={showConfirmation || isSubmitting}
                    />

                    {/* input de confirmação de senha */}
                    <input
                        type={showPassword ? "text" : "password"}
                        placeholder={t("Confirm Password")}
                        aria-label={t("Confirm Password")}
                        value={confirmpassword}
                        onChange={(e) => setConfirmpassword(e.target.value)}
                        required
                        minLength={6}
                        maxLength={20}
                        className={styles.input}
                        disabled={showConfirmation || isSubmitting}
                    />

                    {/* checkbox para mostrar ou ocultar senha */}
                    <div className={styles.checkboxContainer}>
                        <input
                            type="checkbox"
                            className={styles.checkbox}
                            id="mostrarSenha"
                            checked={showPassword}
                            onChange={() => setShowPassword(!showPassword)}
                        />
                        <label htmlFor="mostrarSenha" className={styles.checkboxLabel}>
                            {t("Show Password")}
                        </label>
                    </div>
                    {showConfirmation && (

                        //caixa para inserir código de confirmação
                        <div className={styles.codConfirmation}>
                            <p className={styles.codConfirmationText}>
                                {t("It is necessary to confirm the code sent to your email to activate the account.")}
                            </p>
                            <input
                                type="text"
                                placeholder={t("Confirmation Code")}
                                aria-label={t("Confirmation Code")}
                                className={styles.inputConfirmation}
                                value={code}
                                required
                                maxLength={6}
                                minLength={6}
                                onChange={(e) => setCode(e.target.value)}
                                autoFocus
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleConfirm(e);
                                    }
                                }}
                            />
                        </div>
                    )}

                    {!showConfirmation ? (

                        //botão para enviar cídigo de confirmação
                        <button type="submit" className={styles.button} disabled={isSubmitting}>
                            {isSubmitting ? t("Wait") : t("Register")}
                            {isSubmitting && (
                                <span className={`${styles.ellipsis} ${styles.button}`}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            )}
                        </button>
                    ) : (

                        // botão para confirmar o cadastro
                        <button type="button" className={styles.button} disabled={isSubmitting} onClick={handleConfirm}>
                            {isSubmitting ? t("Wait") : t("Confirm Registration")}
                            {isSubmitting && (
                                <span className={`${styles.ellipsis} ${styles.button}`}>
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </span>
                            )}
                        </button>
                    )}

                    {/* informa que o usuário pode fazer login com google sem pre cadastro */}
                    <div className={styles.googleAppButtonContainer}>
                        <button
                            type="button"
                            className={styles.googleAppButton}
                            onClick={() => window.location.href = '/'}
                        >
                            <FcGoogle className={styles.googleIconApp} />
                            <span className={styles.infoGoogle}>
                            {t("I have a Google account")}
                            </span>
                        </button>
                    </div>
                </form>

                {/* link para página login */}
                <div className={styles.loginContainer}>
                    <span>{t("Already have an account?")}</span>
                    <Link to="/" className={styles.link}>
                        {t("Login")}
                    </Link>
                </div>

            </div>

            {/* mensagem de sucesso ao cadastrar */}
            {showSuccessModal && (
                <div className={styles.modalOverlay}>
                    <div className={styles.modalContent}>
                        <svg className={styles.modalIcon} viewBox="0 0 24 24" fill="none">
                            <circle cx="12" cy="12" r="12" fill="#4BB543" />
                            <path d="M7 13l3 3 7-7" stroke="#fff" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <h2>{t("Registration successful!")}</h2>
                        <p>{t("Your registration has been confirmed successfully. You will be redirected to the login page.")}</p>
                        <button className={styles.modalButton} onClick={handleCloseModal}>
                            {t("Go to Login")}
                        </button>
                    </div>
                </div>
            )}

            {/* modal informativo de 90 dias */}
            {showInfoModal && (
                <div className={styles.modalOverlayInfo}>
                    <div className={styles.modalContentInfo}>
                        <div className={styles.modalHeaderInfo}>
                            <svg className={styles.crownIcon} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M2.5 19H21.5V21H2.5V19ZM2.5 17L4.5 9L9.5 13L12 4L14.5 13L19.5 9L21.5 17H2.5Z" fill="url(#crownGradient)" stroke="url(#crownGradient)" strokeWidth="1" strokeLinejoin="round" />
                                <defs>
                                    <linearGradient id="crownGradient" x1="2" y1="4" x2="22" y2="21" gradientUnits="userSpaceOnUse">
                                        <stop stopColor="#FFD700" />
                                        <stop offset="1" stopColor="#FFA500" />
                                    </linearGradient>
                                </defs>
                            </svg>
                            <h2 className={styles.premiumTitle}>{t("tS notes Premium")}</h2>
                        </div>

                        <div className={styles.modalBodyInfo}>
                            <p className={styles.modalSubtitleInfo}>
                                {t("Use tS notes for free for")}{" " + freeTrialDays + " "}{t("days, no card registration or advance payment required.")}
                            </p>

                            <ul className={styles.benefitsList}>
                                <li>
                                    <svg viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#4BB543" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                    <span>{t("Store your notes in the cloud.")}</span>
                                </li>
                                <li>
                                    <svg viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#4BB543" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                    <span>{t("Real-time synchronization")}</span>
                                </li>
                                <li>
                                    <svg viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#4BB543" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                    <span>{t("Access on all your devices")}</span>
                                </li>
                                <li>
                                    <svg viewBox="0 0 24 24" fill="none"><path d="M5 13l4 4L19 7" stroke="#4BB543" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" /></svg>
                                    <span>{t("No ads or functional limitations")}</span>
                                </li>
                            </ul>
                        </div>

                        {/* mostra tipos de planos disponíveis e valores após periodo gratuíto */}
                        <div className={styles.modalBodyInfoPlans}>
                            <p className={styles.modalSubtitleInfo}>
                                {t("After the free trial period, you can choose one of our plans to continue enjoying all the benefits of tS notes Premium:")}
                            </p>
                            <ul className={styles.infoPromoPlans}>
                                <li className={styles.planCard}>
                                    <div className={styles.planBadge}>{t("Premium")}</div>
                                    <span className={styles.planLabel}>{t("Plans starting from")}</span>
                                    <span className={styles.planValue}>{Number(valorMensal).toLocaleString(regiaoPayment, { style: 'currency', currency: currency })}</span>
                                    <span className={styles.planPeriod}>{t("/ month")}</span>
                                    <span className={styles.nameCoin}>{nameCoin}</span>
                                </li>
                            </ul>
                        </div>

                        <button className={styles.modalButtonInfo} onClick={() => setShowInfoModal(false)}>
                            {t("Start my free trial")}
                        </button>
                    </div>
                </div>
            )}

            {/* mensagens de erro para o usuário */}
            <ToastContainer
                position="top-right"
                autoClose={6000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover
            />
        </div>
    );
}